<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <div class="form-group has-label">
            <label>Lieferant</label>
            <multiselect v-model="order.supplier"
              :options="suppliers"
              track-by="id"
              label="name"
              placeholder="Lieferant auswählen"
              @input="selectSupplier"
            />
          </div>
          <div class="form-group has-label" v-if="warehouses.length > 1">
            <label>Lager</label>
            <multiselect v-model="order.warehouse"
              :options="warehouses"
              track-by="id"
              label="short_name"
              placeholder="Lager auswählen"
              @input="selectWarehouse"
            />
          </div>
          <div class="form-group has-label" v-if="order.supplier && order.supplier.contact_people.length">
            <label>Kontaktperson</label>
            <multiselect v-model="order.contact_person"
              :options="order.supplier.contact_people"
              track-by="id"
              label="fullName"
              @input="selectContactPerson"
            />
            <div class="text-danger invalid-feedback" style="display: block;"
              v-if="valErrors['file']"
            >
              {{ valErrors['file'][0] }}
            </div>
          </div>
          <fg-input label="Empfänger E-Mail Adresse"
            type="text"
            v-model="order.email"
            :error="valErrors['email'] ? valErrors['email'][0] : null"
          />
          <fg-input label="E-Mail Betreff"
            type="text"
            v-model="order.email_subject"
            :error="valErrors['subject'] ? valErrors['subject'][0] : null"
          />
          <l-checkbox v-model="order.append_prices">Einkaufspreise übermitteln</l-checkbox>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group has-label">
                <label>Produkte bestellen</label>
                <multiselect v-model="product"
                  :options="products"
                  track-by="id"
                  :custom-label="({ product }) => product.name"
                  placeholder="Produkt auswählen"
                  selectLabel=""
                >
                  <template slot="option" slot-scope="props">
                    <div>
                      <strong style="font-size: 1.15em">{{ props.option.product.name }}</strong><br>
                      <div style="margin-top: 0.5em">
                        <span style="font-size: 0.9em">
                          P: {{ props.option.price | priceFromCentEuro }} | L: {{ props.option.quantity || 0 }} | B: {{ props.option.product.orders.length ? props.option.product.orders[0].ordered_quantity : 0 }}
                        </span>
                        <template v-if="props.option.product.lager_soll_menge">
                          <br>
                          <span style="font-size: 0.9em">
                            Lager Sollmenge: {{ props.option.product.lager_soll_menge }}
                          </span>
                        </template>
                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="col-sm-3">
              <fg-input label="Menge"
                type="number"
                v-model="quantity"
              />
            </div>
            <div class="col-sm-2">
              <fg-input label="Preis">
                <p class="form-control-static text-right">{{ product ? (product.price * quantity) : '' | priceFromCentEuro }}</p>
              </fg-input>
            </div>
            <div class="col-sm-1 text-center">
              <button class="btn btn-fill btn-primary"
                style="margin-top: 2em;"
                @click.prevent="addProduct"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div v-if="order.products.length" style="margin-bottom: 2em;">
            <div class="row" v-for="addedProduct in order.products" :key="addedProduct.product.product.id">
              <div class="col-sm-6">
                {{ addedProduct.product.product.name }}
              </div>
              <div class="col-sm-3">
                <input type="number" class="form-control valid" v-model="addedProduct.quantity">
              </div>
              <div class="col-sm-2 text-right">
                {{ addedProduct.quantity * addedProduct.product.price | priceFromCentEuro }}
              </div>
              <div class="col-sm-1 text-center">
                <button class="btn btn-fill btn-danger btn-sm"
                  style="vertical-align: sub;"
                  @click.prevent="deleteProduct(addedProduct)"
                >
                  <i class="fa fa-close"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-9">
                <div v-if="order.supplier.min_order_sum > orderSum"
                  style="padding-top: 1rem;"
                >
                  <l-alert type="danger">
                    <strong>Mindestbestellwert: {{ order.supplier.min_order_sum | priceFromCentEuro }}</strong><br>
                    Fügen Sie noch Produkte im Wert von mindestens {{ (order.supplier.min_order_sum - orderSum) | priceFromCentEuro }} hinzu
                  </l-alert>
                </div>
              </div>
              <div class="col-sm-2 text-right">
                <div style="border-top: 4px double; padding-top: 1rem;">{{ orderSum | priceFromCentEuro }}</div>
              </div>
              <div class="col-sm-1"></div>
            </div>
          </div>
          <hr>
          <div class="form-group has-label">
            <label class="d-flex justify-content-between">
              <div>Email Bestelltext</div>
              <div>
                <button class="btn btn-fill btn-sm" :class="editMode ? 'btn-success' : 'btn-info'"
                  @click.prevent="editMode = ! editMode"
                >
                  <i class="fa fa-xs" :class="editMode ? 'fa-check' : 'fa-edit'"></i>
                </button>
              </div>
            </label>
            <div v-text="emailTextFormatted" style="white-space: break-spaces;" v-show="! editMode"></div>
            <textarea class="form-control" v-model="emailText" rows="5" v-show="editMode"></textarea>
          </div>
          <fg-input label="Kommentar">
            <textarea class="form-control" v-model="order.comment" rows="3"></textarea>
          </fg-input>
          <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
        </form>
      </card>
    </div>
    <div class="col-sm-6">
      <transition name="el-fade-in-linear">
        <card v-if="warnschwelleProducts.length">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Produkt</th>
                <th>Auf Lager</th>
                <th>Warnschwelle</th>
                <th>Lager Sollmenge</th>
                <th>Offene Bestellungen</th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="warnschwelleProducts.length">
              <tr v-for="product in warnschwelleProductsSorted" :key="product.id"
                :class="product.hasBeenAdded ? 'has-been-added' : ''"
              >
                <td>
                  <router-link :to="`/products/${product.product.id}`">
                    {{ product.product.name }}
                  </router-link>
                  <span v-if="product.product.lager_soll_menge">
                    ({{ product.product.lager_soll_menge - product.quantity }})
                  </span>
                </td>
                <td class="text-right">{{ product.quantity || 0 }}</td>
                <td class="text-right">{{ product.warnschwelle }}</td>
                <td class="text-right">{{ product.product.lager_soll_menge }}</td>
                <td class="text-right">{{ product.ordered_quantity || 0 }}</td>
                <td class="text-right">
                  <button class="btn btn-primary"
                    @click.prevent="addWarnschwelleProduct(product)"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </card>
      </transition>
    </div>
  </div>
</template>

<script>
import LAlert from 'src/components/Alert'
import formatEmailText from './format-email-text'

export default {
  components: { LAlert },
  props: {
    valErrors: null,
    initOrder: null,
    submitText: null,
    initProduct: null
  },
  data () {
    return {
      order: this.initOrder,
      product: null,
      suppliers: [],
      products: [],
      warnschwelleProducts: [],
      warehouses: [],
      quantity: '',
      editMode: false,
      emailText: this.initOrder.email_text || this.getInitialEmailText(),
      isFirst: true
    }
  },
  methods: {
    selectContactPerson (contactPerson) {
      if (contactPerson) {
        this.order.email = contactPerson.email
        this.order.contact_person_id = contactPerson.id
      } else {
        this.order.email = ''
        this.order.contact_person_id = null
      }
    },
    submit () {
      this.order.supplier_id = this.order.supplier ? this.order.supplier.id : null
      this.order.email_text = this.emailText
      this.$emit('submit', this.order)
    },
    fetchProducts (supplierId) {
      this.$http.get(`/suppliers/${supplierId}/products`).then(({ data }) => {
        this.products = data
        if (this.isFirst) {
          if (this.initProduct) {
            this.product = data.find(({ product }) => +product.id === +this.initProduct)
            if (this.product.product.lager_soll_menge) {
              this.quantity = this.product.product.lager_soll_menge - this.product.quantity
            }
          }
          this.isFirst = false
        }
      })
    },
    fetchWarnschwelleProducts (supplierId) {
      const exclude = this.order.id ? `?exclude=${this.order.id}` : ''
      this.$http.get(`/suppliers/${supplierId}/products/to_order${exclude}`).then(({ data }) => {
        this.warnschwelleProducts = data.map(product => {
          const existsInOrder = this.order.products.findIndex(addedProduct => +addedProduct.product.product.id === +product.id) > -1
          product.hasBeenAdded = existsInOrder
          return product
        })
      })
    },
    selectSupplier (supplier) {
      this.product = null
      this.order.products = []
      supplier ? this.fetchProducts(supplier.id) : this.products = []
      supplier ? this.fetchWarnschwelleProducts(supplier.id) : this.warnschwelleProducts = []
      this.order.email = supplier ? supplier.email : ''
    },
    selectWarehouse (warehouse) {
      this.order.warehouse_id = warehouse ? warehouse.id : null
    },
    addProduct () {
      const index = this.order.products.findIndex(({ product }) => +product.id === +this.product.id)
      if (index >= 0) {
        this.order.products[index].quantity += +this.quantity
      } else {
        this.order.products.push({
          product: this.product,
          quantity: +this.quantity
        })
        this.markWarnschwellenProduct(this.product.product.id, true)
      }
      this.product = null
      this.quantity = ''
    },
    addWarnschwelleProduct (product) {
      const quantity = product.product.lager_soll_menge - product.quantity - product.ordered_quantity
      const index = this.order.products.findIndex(addedProduct => +addedProduct.product.product.id === product.product.id)
      if (index >= 0) {
        this.order.products[index].quantity += (quantity || 1)
      } else {
        this.order.products.push({
          product: product,
          quantity: (quantity || 1)
        })
      }
      product.hasBeenAdded = true
    },
    deleteProduct (productToDelete) {
      const index = this.order.products.findIndex(({ product }) => {
        return product.product.id === productToDelete.product.product.id
      })
      this.markWarnschwellenProduct(productToDelete.product.product.id, false)
      this.order.products.splice(index, 1)
    },
    markWarnschwellenProduct (productToCheck, hasBeenAdded) {
      const warnschwelleProduct = this.warnschwelleProducts.find(({ product }) => {
        return product.id === productToCheck
      })
      if (warnschwelleProduct) {
        warnschwelleProduct.hasBeenAdded = hasBeenAdded
      }
    },
    getInitialEmailText () {
      return 'Sehr geehrte Damen und Herren,' + '\r\n\r\n' +
        'hiermit bestellen wir bei Ihnen die folgenden Produkte:' + '\r\n\r\n' +
        'REPLACE_PRODUCTS' + '\r\n\r\n' +
        'Bei etwaigen Fragen oder Lieferschwierigkeiten bitten wir um schnellstmögliche Kontaktaufnahme!' + '\r\n\r\n' +
        'Vielen Dank im Voraus,' + '\r\n' + '\r\n' +
        this.$store.state.authUser.name + '\r\n' +
        this.$store.state.authUser.email +
        `${this.$store.state.authUser.phone ? '\r\n' + this.$store.state.authUser.phone : ''}`
    }
  },
  computed: {
    emailTextFormatted () {
      const productsMapped = this.order.products.map(product => {
        let bla = `${product.quantity} x ${product.product.product.name}`
        if (this.order.append_prices) {
          bla += ` (à ${this.$options.filters.priceFromCentEuro(product.product.price)})`
        }
        return bla
      })
      return formatEmailText(productsMapped, this.emailText)
    },
    orderSum () {
      return this.order.products.reduce((sum, product) => {
        return sum + (product.product.price * product.quantity)
      }, 0)
    },
    warnschwelleProductsSorted () {
      return [...this.warnschwelleProducts].sort((productA, productB) => {
        return (productA.hasBeenAdded === productB.hasBeenAdded) ? 0 : productA.hasBeenAdded ? 1 : -1
      })
    }
  },
  created () {
    this.$http.get('/suppliers').then(({ data }) => { this.suppliers = data })
    this.$http.get('/warehouses').then(({ data }) => {
      if (data.length === 1) {
        this.order.warehouse_id = data[0].id
      }
      this.warehouses = data
    })
    if (this.order.supplier) {
      this.fetchProducts(this.order.supplier.id)
      this.fetchWarnschwelleProducts(this.order.supplier.id)
    }
  }
}
</script>

<style scoped>
  .has-been-added {
    opacity: 0.5;
  }
</style>
